module.exports = __webpack_public_path__ + "static/index/img/baikal-505.f6e6a655.jpg";